import { ENGLISH } from './supportedLanguages';

const LOGIN_AR = 'شكراً. يرجى إدخال كلمة السر الخاصة بك.';
const LOGIN_EN = 'Thank you.  Please enter your password.';
export function getLoginMessage(language = ENGLISH) {
  return language === ENGLISH ? LOGIN_EN : LOGIN_AR;
}

const LOGIN_RETRY_AR = 'عذرا ، كلمة مرور غير صالحة ، يرجى المحاولة مرة أخرى!';
const LOGIN_RETRY_EN = 'Sorry, invalid password, please try again!';
export function getLoginRetryMessage(language = ENGLISH) {
  return language === ENGLISH ? LOGIN_RETRY_EN : LOGIN_RETRY_AR;
}
